import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { GlobeIcon, MapPinIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
export function ClassicGeography() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-662" data-mp="1x0eb1vbmfzk5">
      <div className="absolute inset-0 pointer-events-none" data-id="element-663" data-mp="21y64wuvttvqz">
        <div className="absolute top-0 left-1/3 w-[420px] h-[420px] rounded-full bg-cyan-100/25 blur-3xl hidden sm:block" data-id="element-664" data-mp="1nabb1b631lcb" />
        <div className="absolute bottom-0 right-0 w-[320px] h-[320px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-665" data-mp="1s7urmhq96a7f" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-666" data-mp="2fwnocgep8m33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-667" data-mp="2kr0cv4v18nlp">
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-668" data-mp="42v15q3z74la">
            <GlobeIcon className="w-4 h-4" data-id="element-669" data-mp="3vhafnayj1r21" />
            {lang === 'EN' ? 'Geography' : 'Географія'}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight max-w-3xl mx-auto" data-id="element-670" data-mp="dzr8vtm1vmos">
            {c.geography.title}
          </h2>
          <p className="mt-4 text-lg text-navy-500 max-w-2xl mx-auto" data-id="element-671" data-mp="n28vwa9j4jcu">
            {c.geography.lead}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4" data-id="element-672" data-mp="j0nb82qr70s3">
          {c.geography.regions.map((region, i) => {
          const isWorldwide = i === c.geography.regions.length - 1;
          return <motion.div key={region} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.45,
            delay: 0.1 + i * 0.07
          }} className={`flex flex-col items-center justify-center gap-3 p-6 rounded-2xl border text-center ${isWorldwide ? 'bg-gradient-to-br from-primary-600 to-primary-500 border-primary-500 text-white shadow-lg shadow-primary-600/20 col-span-2 lg:col-span-1' : 'bg-white border-navy-200 shadow-sm'}`} data-id="element-673" data-mp="2ktld0o2id3p6" data-mpi={i}>
                {isWorldwide ? <GlobeIcon className="w-5 h-5" data-id="element-674" data-mp="1gg1ua843pias" /> : <MapPinIcon className="w-5 h-5 text-primary-500" data-id="element-675" data-mp="1lewcb7u8v2tu" />}
                <span className={`text-base font-bold ${isWorldwide ? 'text-white' : 'text-navy-900'}`} data-id="element-676" data-mp="1qe99aletxqa5">
                  {region}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}